  import React, { useState, useEffect } from "react";
  import * as XLSX from "xlsx";
  import { getAttendanceByMonthYear, deleteAttendanceByMonthYear, addAttendence,} from "../../api/attendanceApi";
  import {getLeaveReport} from "../../api/leavesApi";

  import { useNavigate } from "react-router-dom";
  import "./AttendanceTable.css"; // Import local CSS
  import { hasRight } from "../../utils/userRights"; 

  export default function AddAttendanceExcel() {
    const navigate = useNavigate();
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [attendanceData, setAttendanceData] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isDataExists, setIsDataExists] = useState(false);

    const [leaveReport, setLeaveReport] = useState([]);
    const [showReport, setShowReport] = useState(false);
    const [loadingReport, setLoadingReport] = useState(false);


    let username = sessionStorage.getItem("username");

    useEffect(() => {
      if (month && year) {
        checkExistingAttendance();
      }
    }, [month, year]);

    const columnMapping = {
      employeeid: "ID",
      code: "Emp Code",
      name: "Name",
      attendancemonth: "Month",
      attendanceyear: "Year",
      totalworkingdays: "Working Days",
      halfdays: "Half Days",
      cl: "CL",
      sl: "SL",
      pl: "PL",
      other1: "Other1",  
      other2: "Other2",   
      other3: "Other3",
      noofpresentdays: "Present Days",
      absentdays: "Absent Days",
      extrahourwork: "OT Hours",
      totaldays: "Total Days",
      deptid: "Department",
      
    };

    const getFriendlyName = (key) => {
      const normalizedKey = key.toLowerCase();
      return columnMapping[normalizedKey] || key;
    };

    const getColumnWidth = (key) => {
      if (key === "name") return "150px";
      if (key === "code") return "100px";
      if (key === "noofpresentdays") return "80px";
      return "70px";
    };

    const getTextAlign = (key) => {
      if (key === "sr") return "center";
      const numericFields = [
        "totalworkingdays",
        "halfdays",
        "cl",
        "sl",
        "pl",
        "other1",
        "other2",
        "other3",
        "noofpresentdays",
        "absentdays",
        "extrahourwork",
        "totaldays",
        "attendancemonth",
        "attendanceyear",
        
      ];
      return numericFields.includes(key.toLowerCase()) ? "right" : "left";
    };


    const checkExistingAttendance = async () => {
      try {
        const data = await getAttendanceByMonthYear(month, year);
        if (data && data.length > 0) {
          setAttendanceData(data);
          setIsDataExists(true);
        } else {
          setAttendanceData([]);
          setIsDataExists(false);
        }
      } catch (error) {
        console.error("Error checking existing attendance:", error);
        setAttendanceData([]);
        setIsDataExists(false);
      }
    };

    const deleteAndUploadNew = async () => {
      try {
        const result = await deleteAttendanceByMonthYear(month, year);
        alert(result.message);
        setAttendanceData([]);
        setDisplayData([]);
        setIsDataExists(false);
      } catch (error) {
        alert(error.message);
      }
    };

    const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      let excelData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      // Map Excel column names to DB column names
      const excelToDbMapping = {
        "Present Days": "noofpresentdays",
        "Month": "attendancemonth",
        "Year": "attendanceyear",
        "Absent Days": "absentdays"
      };

      excelData = excelData.map((row) => {
        let newRow = {};
        for (let key in row) {
          const dbKey = excelToDbMapping[key] || key.toLowerCase();
          newRow[dbKey] = row[key];
        }
        return newRow;
      });

      // Check Month/Year consistency
      const invalidRow = excelData.find(
        (row) =>
          parseInt(row["attendancemonth"]) !== parseInt(month) ||
          parseInt(row["attendanceyear"]) !== parseInt(year)
      );

      if (invalidRow) {
        alert(
          `Mismatch! You entered Month=${month}, Year=${year}, but file contains Month=${invalidRow["attendancemonth"]}, Year=${invalidRow["attendanceyear"]}`
        );
        setDisplayData([]);
        setAttendanceData([]);
        e.target.value = "";
        return;
      }

      setDisplayData(excelData);

      // Add extra fields before saving
      let jsonData = excelData.map((row) => ({
        ...row,
        attendancemonth: month, // enforce correct month
        attendanceyear: year,   // enforce correct year
        crUser: username || "Unknown",
        crDate: new Date().toISOString(),
        trUser: null,
        trDate: null,
        deleted: "N",
      }));

      setAttendanceData(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };



  const handleUpload = async () => {
    try {
      const res = await addAttendence(attendanceData);

      if (res.invalidCodes && res.invalidCodes.length > 0) {
        alert(`${res.message}\n\nInvalid Codes:\n${res.invalidCodes.join("\n")}`);
      } else {
        alert(res.message || "Data uploaded successfully!");
        navigate("/welcome");
      }
    } catch (error) {
      if (error.invalidCodes) {
        alert(`${error.message}\n\nInvalid Codes:\n${error.invalidCodes.join("\n")}`);
      } else {
        alert(error.message || "Upload failed.");
      }
      console.error("Upload Error:", error);
    }
  };

    const handleNoNeedUpload = () => {
      navigate("/welcome");
    };

    const handleClear = () => {
      setMonth("");
      setYear("");
      setAttendanceData([]);
      setDisplayData([]);
      setIsDataExists(false);
    };

      const excelColLabel = (n) => {
        let s = "";
        while (n >= 0) {
          s = String.fromCharCode(65 + (n % 26)) + s;
          n = Math.floor(n / 26) - 1;
        }
      return s;
    };

    // const handleViewLeaveReport = async () => {
    //   if (!month || !year) {
    //     alert("Please enter Month and Year first.");
    //     return;
    //   }
    //   try {
    //     setLoadingReport(true);
    //     const res = await getLeaveReport(month, year);
    //     if (res && res.length > 0) {
    //       setLeaveReport(res);
    //       setShowReport(true);
    //     } else {
    //       alert("No leave report found for this month and year.");
    //       setShowReport(false);
    //     }
    //   } catch (err) {
    //     console.error(err);
    //     alert("Failed to fetch leave report.");
    //   } finally {
    //     setLoadingReport(false);
    //   }
    // };

      const handleViewLeaveReport = async () => {
  if (!month || !year) {
    alert("Please enter Month and Year first.");
    return;
  }
  try {
    setLoadingReport(true);
    const res = await getLeaveReport(month, year);
    if (res && res.length > 0) {
      setLeaveReport(res);
      setShowReport(true);
    } else {
      // If backend returns an empty array with 200 OK
      alert("No leave report found for this month and year.");
      setShowReport(false);
    }
  } catch (err) {
    console.error(err);
    const errorMessage =
      err?.response?.data?.message || err.message || "Failed to fetch leave report.";
    alert(errorMessage);
    setShowReport(false);
  } finally {
    setLoadingReport(false);
  }
};

      const pivotLeaveReport = (data) => {
        const pivot = {};
      
        data.forEach((item) => {
          const empCode = item.employeeCode;
          if (!pivot[empCode]) {
            pivot[empCode] = {
              EmpCode: empCode,
              Name: item.fullName,
              CL: 0,
              SL: 0,
              PL: 0,
              Other1: 0,
              Other2: 0,
              Other3: 0,
            };
          }
          pivot[empCode][item.leaveCode] = item.totalDaysApproved;
        });
      
        return Object.values(pivot);
      };

    const handleClearReport = () => {
      setLeaveReport([]);
      setShowReport(false);
    };

    return (
      <div className="container mt-4">
        <h2>Generate Attendance</h2>
        <div className="mb-3">
          <div className="row">
            <div className="col-3">
              <input
                type="number"
                placeholder="Month (1-12)"
                value={month}
                min="1"
                max="12"
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "" || (value >= 1 && value <= 12)) {
                    setMonth(value);
                  }
                }}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-3">
              <input
                type="number"
                placeholder="Year (YYYY)"
                value={year}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.length <= 4) {
                    setYear(value);
                  }
                }}
                className="form-control form-control-sm"
              />
            </div>
            {/* Add "Show Leave Report" button here */}
            
            {!isDataExists && (
              <div className="col-4 text-end">
                <button
                  className="btn btn-success me-1 btn-sm"
                  onClick={handleViewLeaveReport}
                  disabled={!month || !year}
                >
                  Show Leave Report
                </button>

                <button
                  className="btn btn-secondary btn-sm"
                  onClick={handleClearReport}
                  disabled={leaveReport.length === 0}
                >
                  Clear Report
                </button>
              </div>
            )}

          </div>
        </div>
        
      

        {!isDataExists && showReport && leaveReport.length > 0 && (
          <div className="mt-4 mb-3"> {/* added mb-3 for bottom spacing */}
            <h5>📊 Leave Report</h5>
            <div className="table-responsive">
              <table className="table table-bordered table-striped table-hover compact-table">
        
                <thead>
                  <tr>
                    {["EmpCode", "Name", "CL", "SL", "PL", "Other1", "Other2", "Other3"].map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {pivotLeaveReport(leaveReport).map((row, index) => (
                    <tr key={index}>
                      {["EmpCode", "Name", "CL", "SL", "PL", "Other1", "Other2", "Other3"].map((col, i) => (
                        <td key={i}>{row[col]}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}


        {isDataExists ? (
          <>
            <p style={{ color: "red" }}>
              Attendance for this month/year already exists
            </p>
            <div className="table-responsive">
              <table className="table table-bordered table-striped table-hover custom-table">
                <thead className="table-dark">
                  <tr>
                    <th style={{ width: "50px", textAlign: "center" }}>Sr. No.</th>
                    {Object.keys(attendanceData[0])
                      .filter((key) => !["deptid", "employeeid"].includes(key.toLowerCase()))
                      .map((key) => (
                        <th
                          key={key}
                          style={{
                            width: getColumnWidth(key),
                            textAlign: getTextAlign(key),
                          }}
                        >
                          {getFriendlyName(key)}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {attendanceData.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      {Object.entries(row)
                        .filter(([key]) => !["deptid", "employeeid"].includes(key.toLowerCase()))
                        .map(([key, val], i) => (
                          <td
                            key={i}
                            style={{
                              width: getColumnWidth(key),
                              textAlign: getTextAlign(key),
                            }}
                          >
                            {val}
                          </td>
                        ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <>
              {/* <button onClick={deleteAndUploadNew} className="btn btn-warning mt-3">
                Delete & Upload New
              </button>
              <button onClick={handleNoNeedUpload} className="btn btn-warning mt-3 ms-2">
                No Need Upload
              </button> */}

              {hasRight("AddAttendanceExcel", "delete") && (
                <button onClick={deleteAndUploadNew} className="btn btn-warning mt-3">Delete & Upload New</button>
              )}
              {hasRight("AddAttendanceExcel", "view") && (
                <button onClick={handleNoNeedUpload} className="btn btn-warning mt-3 ms-2">No Need Upload</button>
              )}
              <button onClick={handleClear} className="btn btn-danger mt-3 ms-2">
                Clear
              </button>
            </>
          </>
        ) : (
          <>
            <div className="mt-3">
              <input
                type="file"
                accept=".xlsx, .xls"
                className="form-control"
                disabled={!month || !year}
                onChange={handleFileUpload}
              />
            </div>
            <div className="table-responsive mt-3">
              <table className="table table-bordered table-striped table-hover">  
                <thead>
                  <tr
                    className="text-center"
                    style={{
                      fontSize: "0.75rem",
                      height: "28px",
                      backgroundColor: "#ffeeba",
                      color: "#000",
                    }}
                  >
                    {["srno", ...Object.keys(columnMapping)
                      .filter((key) => !["deptid", "employeeid"].includes(key.toLowerCase()))]
                      .map((key, idx) => (
                        <th
                          key={`alpha-${idx}`}
                          scope="col"
                          style={{ padding: "6px 8px", width: idx === 0 ? "50px" : "auto" }}
                        >
                          {excelColLabel(idx)}
                        </th>
                      ))}
                  </tr>

                  <tr className="table-dark">
                    <th style={{ width: "50px", textAlign: "center" }}>Sr. No.</th>
                    {Object.keys(columnMapping)
                      .filter((key) => !["deptid", "employeeid"].includes(key.toLowerCase()))
                      .map((key) => (
                        <th
                          key={key}
                          style={{
                            width: getColumnWidth(key),
                            textAlign: getTextAlign(key),
                          }}
                        >
                          {columnMapping[key]}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {displayData.length > 0 ? (
                    displayData.map((row, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                        {Object.entries(row)
                          .filter(([key]) => !["deptid", "employeeid"].includes(key.toLowerCase()))
                          .map(([key, val], i) => (
                            <td
                              key={i}
                              style={{
                                width: getColumnWidth(key),
                                textAlign: getTextAlign(key),
                              }}
                            >
                              {val}
                            </td>
                          ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={Object.keys(columnMapping).length + 1} className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* {displayData.length > 0 && (
              <button onClick={handleUpload} className="btn btn-success mt-3">
                Save
              </button>
            )} */}
            {displayData.length > 0 && hasRight("AddAttendanceExcel", "add") && (
              <button onClick={handleUpload} className="btn btn-success mt-3">Save</button>
            )}
          </>
        )}
      </div>
    );
  }



